import { styled } from "styled-components";

const FixturesContainer = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  padding: 2rem 1rem;
`;

const PageTitle = styled.h1`
  margin: 0 0 2rem 0;
  font-size: 2.5rem;
  font-weight: bold;
`;

const FilterSection = styled.div`
  margin-bottom: 2rem;
  display: flex;
  gap: 1rem;
`;

const FilterButton = styled.button<{ active?: boolean }>`
  padding: 0.5rem 1rem;
  border: 2px solid var(--primary);
  border-radius: 4px;
  background-color: ${props => props.active ? 'var(--primary)' : 'transparent'};
  color: ${props => props.active ? 'white' : 'var(--primary)'};
  font-weight: bold;
  cursor: pointer;
  
  &:hover {
    background-color: var(--primary);
    color: white;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const PaginationSection = styled.div`
  margin-top: 2rem;
  display: flex;
  justify-content: center;
  gap: 1rem;
  align-items: center;

  .page-info {
    color: var(--gray);
  }
`;

const ShowAllButton = styled.button`
  margin-top: 2rem;
  padding: 0.75rem 1.5rem;
  border: 2px solid var(--primary);
  border-radius: 4px;
  background-color: transparent;
  color: var(--primary);
  font-weight: bold;
  cursor: pointer;
  display: block;
  margin-left: auto;
  margin-right: auto;
  
  &:hover {
    background-color: var(--primary);
    color: white;
  }
`;

const LoadingState = styled.div`
  text-align: center;
  padding: 2rem;
  color: var(--gray);
`;

const ErrorState = styled.div`
  text-align: center;
  padding: 2rem;
  color: var(--gray);
  background: white;
  border-radius: 8px;
  margin-top: 1rem;
`;

const NoFixturesMessage = styled.div`
  text-align: center;
  padding: 2rem;
  background: white;
  border-radius: 8px;
  margin-top: 1rem;
  color: var(--gray);
`;

export { FixturesContainer, PageTitle, FilterSection, FilterButton, PaginationSection, ShowAllButton, LoadingState, ErrorState, NoFixturesMessage };